import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { retry, catchError, map } from "rxjs/operators";
import { SnotifyService } from "ng-snotify";

@Injectable({
  providedIn: 'root'
})
export class RemoteApiService {

  settings: any;
  authkey: any;
  currentTime: number;
  noOfApiCall = 0;
  token: string = "";
  NETWORK_ERROR: string = "Please Check you Internet Connection";
  constructor(
    private _http: HttpClient,
    private notify: SnotifyService,
    private router: Router,
  ) {

    let currentDate = new Date();
    this.currentTime = currentDate.getTime();

  }

  handleError(err) {
    if (err.error instanceof ErrorEvent) {
      // client-side error
      console.error("An error occurred:", err.error.message);
    } else {
      // server-side error
      console.error(
        `Backend returned code ${err.status}, ` + `body was: ${err.error}`,
        `body was: ${JSON.stringify(err)}`
      );
    }
    if (!err.ok && err.status == 0) {
      this.notify.clear();
      this.notify.error(this.NETWORK_ERROR);
    }
    if (err .error.status === 406 || err .status === 406 || err .status === 400 || err .error.status === 400) {
      this.notify.clear();
     // this.notify.error(err.error.message);
      this.notify.error(err.error.message ?err.error.message:JSON.parse(err.error).message);
    }
    if(err .error.status===401||err .status===401){
      this.router.navigate(["payment"]);
      this.notify.clear();
      this.notify.error("Erro occoured");
    }
    return [{ response: err.error }];
  }

  getExecuteAPI(callurl, input: any = {}): Observable<any> {


    let headers = new HttpHeaders();
    headers = headers
      .set("auth",  btoa(this.authkey))
      .set("token", this.token)
      .set("timestamp", this.currentTime.toString())
      .set("deviceType", "6");
    let param = "";
    if (input) {
      param = " ";
      for (let key in input) {
        param = param + key + "=" + input[key] + "&";
      }
      param = param.substring(0, param.length - 1);
    }
    return this._http
      .get<any>(callurl + param, { headers: headers })
      .pipe(
        map((res: any) => {
          // this.emitter.setLoader(0);
          // this.spinner.hide();
          return res;
        }),
        retry(1),
        catchError(this.handleError.bind(this))
      );
  }

  // Post request
  postExecuteAPI(
    retryTry,
    callurl,
    input: any = {},
    isLoaderOn: any = {}
  ): Observable<any> {
    // this.emitter.setLoader(1);
    let headers = new HttpHeaders();


    return this._http.post(callurl, input, {}).pipe(
      map((res: any) => {

        return res;
      }),
      retry(retryTry),
      catchError(this.handleError.bind(this))
    );
  }



  // Post formdata request
 postExecuteAPIFormData(
  callurl,
  input: any = {},
): Observable<any> {

  let formData = new FormData();


    if (input) {
      for (let key in input) {
        formData.append (key,  input[key] );
      }
    }


  return this._http.post(callurl, formData, { }).pipe(
    map((res: any) => {


      return res;
    }),
    retry(1),
    catchError(this.handleError.bind(this))
  );
}



  // Post formdata request
  postURLEncodedExecuteAPI(
    callurl,
    input: any = {},
  ): Observable<any> {

    let body = new URLSearchParams();

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  };

      if (input) {
        for (let key in input) {
          body.set(key, input[key] );
        }
      }


    return this._http.post(callurl,  body.toString(), options).pipe(
      map((res: any) => {


        return res;
      }),
      retry(1),
      catchError(this.handleError.bind(this))
    );
  }

}
